import { Response } from 'lib/api/type';
import { queryApi } from 'lib/api';

export type ExternalSignModel = {
  link_code: string;
  order_id: number;
};

export interface ExternalSignResponse extends Response {
  command: {
    sign_info: ExternalSignModel;
  };
}

export type CourierParam = {
  order_id: number; // 주문아이디
  courier_id: string; // 택배회사아이디
  courier_name: string; // 택배회사이름
  invoice_num: string; // 송장번호
};

export interface CourierResponse extends Response {
  command: {
    order_id: number; // 주문아이디
    courier_id: string; // 택배회사아이디
    courier_name: string; // 택배회사이름
    invoice_num: string; // 송장번호
    delivery_state: number;
  };
}

export const getExternalSign = (data: {
  external_token: string;
}): Promise<ExternalSignResponse> => queryApi('mint/account/sign', data);

export const getCourierInfo = (data: {
  order_id: number;
}): Promise<CourierResponse> => queryApi('mint/courier/get', data);

export const setOrderCourier = (data: CourierParam): Promise<Response> =>
  queryApi('mint/order/courier', data);
